<template>
    <div>
        <q-table
            ref="table"
            :data="selected_items"
            :columns="columns"
            selection="multiple"
            :selected.sync="selected"
            row-key="content_id"
            :pagination.sync="selected_server_pagination"
            @request="request_selected"
            :loading="loading"
            :no-data-label="$t('no_data_avaliable')"
            :no-results-label="$t('no_results_found')"
            :loading-label="$t('loading_data')"
            :rows-per-page-label="$t('items_per_page')"
            :rows-per-page-options="[0]"
            binary-state-sort
            class="q-mt-lg"
            >

            <template slot="top" slot-scope="props">
                <div class="col" />
                <q-btn color="negative" icon="far fa-trash" :label="$t('remove')" @click="confirm_remove = true" v-if="selected.length > 0" class="q-mr-md" />
                <q-btn color="secondary" icon="far fa-plus" :label="$t('add_webinars')" @click="showAddTrainings()" :disable="!manage_trails" />
            </template>

            <q-tr slot="header" slot-scope="props" :props="props">
                <q-th auto-width>
                    <q-checkbox v-model="props.selected" indeterminate-value="some" :disable="!manage_trails"/>
                </q-th>

                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                    {{ $t(col.label) }}
                </q-th>
            </q-tr>

            <template slot="body" slot-scope="props">
                <q-tr :props="props">
                    <q-td auto-width>
                        <q-checkbox color="primary" v-model="props.selected" :disable="!manage_trails"/>
                    </q-td>

                    <q-td key="content_id" :props="props" auto-width>
                        {{ props.row.content_id }}
                    </q-td>

                    <q-td key="content_code" :props="props" auto-width>
                        {{ props.row.content_code }}
                    </q-td>

                    <q-td key="content_title" :props="props">
                        {{ props.row.content_title }}
                    </q-td>

                    <q-td key="score" :props="props">
                        {{ props.row.score }}
                    </q-td>

                    <q-td key="transmission_date" :props="props">
                        {{ props.row.transmission_date }}
                    </q-td>

                    <q-td key="status" :props="props" auto-width>
                        <q-chip small :icon="getIconStatus(props.row.status)" :color="getColorStatus(props.row.status)" class="full-width">
                            {{ $t(getStatus(props.row.status)) }}
                        </q-chip>
                    </q-td>
                </q-tr>
            </template>
        </q-table>

        <q-modal v-model="show_add_trainings" :content-css="{minWidth: getMinWidth, maxWidth: getMaxWidth, minHeight: '80vh'}" @hide="clearSelection()" @show="clearSelection()" @escape-key="clearSelection()">
            <q-modal-layout>
                <q-toolbar slot="header">
                    <q-btn flat round dense @click="show_add_trainings = false" icon="fas fa-times" />
                    <q-toolbar-title>
                        {{ $t('trainings') }}
                    </q-toolbar-title>
                </q-toolbar>

                <div class="layout-padding">
                    <q-table
                        :data="not_selected_items"
                        :columns="columns"
                        :pagination.sync="not_selected_server_pagination"
                        :filter="filter_not_selected"
                        @request="request_not_selected"
                        :loading="loading"
                        selection="multiple"
                        :selected.sync="selected"
                        row-key="content_id"
                        :no-data-label="$t('no_data_avaliable')"
                        :no-results-label="$t('no_results_found')"
                        :loading-label="$t('loading_data')"
                        :rows-per-page-label="$t('items_per_page')"
                        :rows-per-page-options="[0]"
                        binary-state-sort
                        >

                        <template slot="top" slot-scope="props">
                            <q-search v-model="filter_not_selected" icon="far fa-search" :placeholder="$t('search')" :float-label="$t('search')" class="q-mr-lg" :debounce="500" />

                            <div class="col" />

                            <q-btn color="positive" icon="far fa-save" :label="$t('add_webinars')" @click="addSelectedTrainings()" v-if="selected.length > 0" class="q-mr-md" />
                        </template>

                        <q-tr slot="header" slot-scope="props" :props="props">
                            <q-th auto-width>
                                <q-checkbox v-model="props.selected" indeterminate-value="some" />
                            </q-th>

                            <q-th v-for="col in props.cols" :key="col.name" :props="props">
                                {{ $t(col.label) }}
                            </q-th>
                        </q-tr>

                        <q-tr slot="body" slot-scope="props" :props="props">
                            <q-td auto-width>
                                <q-checkbox color="primary" v-model="props.selected" />
                            </q-td>

                            <q-td key="content_id" :props="props" auto-width>
                                {{ props.row.content_id }}
                            </q-td>

                            <q-td key="content_code" :props="props" auto-width>
                                {{ props.row.content_code }}
                            </q-td>

                            <q-td key="content_title" :props="props">
                                {{ props.row.content_title }}
                            </q-td>

                            <q-td key="score" :props="props">
                                {{ props.row.score }}
                            </q-td>

                            <q-td key="transmission_date" :props="props">
                                {{ props.row.transmission_date }}
                            </q-td>

                            <q-td key="status" :props="props" auto-width>
                                <q-chip small :icon="getIconStatus(props.row.status)" :color="getColorStatus(props.row.status)" class="full-width">
                                    {{ $t(getStatus(props.row.status)) }}
                                </q-chip>
                            </q-td>
                        </q-tr>
                    </q-table>
                </div>
            </q-modal-layout>
        </q-modal>

        <q-dialog v-model="confirm_remove" @ok="removeTrainings">
            <span slot="title">{{ $t('remove_webinars') }}</span>

            <span slot="message">{{ $t('confirm_remove_webinars') }}</span>

            <template slot="buttons" slot-scope="props">
                <q-btn color="primary" :label="$t('cancel')" @click="confirm_remove = false" />
                <q-btn color="negative" :label="$t('remove')" @click="removeTrainings()" />
            </template>
        </q-dialog>

        <div class="row gutter-sm justify-end q-mt-lg">
            <div class="col-xs-12 col-sm-3">
                <q-btn color="tertiary" class="full-width" :label="$t('back')" icon="far fa-chevron-left" @click="$router.push({ name: 'admin_trails' })" />
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { date } from 'quasar'
import * as moment from 'moment'
import * as tz from 'moment-timezone'

export default {
    i18nOptions: { namespaces: [ "custom", "common", "trails", "admin"] },

    props:['manage_trails'],

    data() {
        return {
            selected_server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: 0,
                descending: false,
                sortBy: 'order'
            },
            not_selected_server_pagination: {
                page: 1,
                rowsNumber: 10,
                rowsPerPage: 5,
                descending: false,
                sortBy: null
            },
            loading: false,
            id_trail: '',
            selected: [],
            columns: [
                {
                    name: 'content_id',
                    required: true,
                    label: '#',
                    align: 'left',
                    field: 'content_id',
                    sortable: false,
                },
                {
                    name: 'content_code',
                    required: true,
                    label: 'code',
                    align: 'left',
                    field: 'content_code',
                    sortable: false,
                },
                {
                    name: 'content_title',
                    required: true,
                    label: 'webinar',
                    align: 'left',
                    field: 'content_title',
                    sortable: false,
                },
                {
                    name: 'score',
                    required: true,
                    label: 'score',
                    align: 'left',
                    field: 'score',
                    sortable: false,
                },
                {
                    name: 'transmission_date',
                    required: true,
                    label: 'date',
                    align: 'left',
                    field: 'transmission_date',
                    sortable: false,
                },
                {
                    name: 'status',
                    required: true,
                    label: 'status',
                    align: 'left',
                    field: 'status',
                    sortable: false,
                }
            ],
            selected_items: [],
            not_selected_items: [],
            new_order: '',
            confirm_remove: false,
            show_add_trainings: false,
            filter_not_selected: ''
        }
    },

    computed: {
        ...mapGetters({
            access_token: 'common/access_token'
        }),

        getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        },

        getMaxWidth() {
            if (this.$q.platform.is.mobile) return '100vw'
            else return '90vw'
        },

        getMinWidth() {
            if (!this.$q.platform.is.mobile) return '90vw'
        }
    },

    methods: {
        request_selected({ pagination }) {
            this.loading = true
            this.selected_items = []
            this.selected_server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                'page_size': this.selected_server_pagination.rowsPerPage,
                'page': this.selected_server_pagination.page,
                'search': this.filter,
                'ordering': order_by
            }

            this.$axios.get(`/admin_trails/trail/${this.id_trail}/webcasts/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.selected_server_pagination.rowsNumber = response.data.count

                this.selected_items = response.data.results.map(e => ({
                    ...e,
                    transmission_date: moment(e.transmission_date).tz(e.timezone).format('DD/MM/YYYY HH:mm')
                }))
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.loading = false
            })
        },

        request_not_selected({ pagination }) {
            this.loading = true
            this.not_selected_items = []
            this.not_selected_server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                'page_size': this.not_selected_server_pagination.rowsPerPage,
                'page': this.not_selected_server_pagination.page,
                'search': this.filter_not_selected,
                'ordering': order_by
            }

            this.$axios.get(`/admin_trails/trail/${this.id_trail}/webcasts/out/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.not_selected_server_pagination.rowsNumber = response.data.count

                this.not_selected_items = response.data.results.map(e => ({
                    ...e,
                    transmission_date: moment(e.transmission_date).tz(e.timezone).format('DD/MM/YYYY HH:mm')
                }))
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.loading = false
            })
        },

        showAddTrainings() {
            this.show_add_trainings = true
            this.request_not_selected({ pagination: {
                    page: 1,
                    rowsNumber: 10,
                    rowsPerPage: 5,
                    descending: false,
                    sortBy: 'order'
                }
            })
        },

        addSelectedTrainings() {
            this.$q.loading.show()

            let data = {
                items: this.selected.map(e => e.content_id)
            }

            this.$axios.post(`/admin_trails/trail/${this.id_trail}/webcasts/`, data, this.getHeader)
            .then(response => {
                this.show_add_trainings = false
                this.request_selected({ pagination: {
                        page: 1,
                        rowsNumber: 10,
                        rowsPerPage: 0,
                        descending: false,
                        sortBy: 'order'
                    }
                })

                this.$q.notify({
                    message: this.$t('webinar_add_success'),
                    type: 'positive',
                    icon: 'fal fa-save'
                })
            })
            .catch(e => {
                this.$q.notify({
                    message: this.$t('webinar_add_error'),
                    type: 'negative',
                    icon: 'fal fa-ban'
                })

                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        removeTrainings() {
            this.$q.loading.show()

            let data = {
                items: this.selected.map(e => e.content_id)
            }

            this.$axios.post(`/admin_trails/trail/${this.id_trail}/webcasts/delete/`, data, this.getHeader)
            .then(response => {
                this.confirm_remove = false
                this.selected = []
                this.request_selected({ pagination: {
                        page: 1,
                        rowsNumber: 10,
                        rowsPerPage: 0,
                        descending: false,
                        sortBy: 'order'
                    }
                })
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.$q.loading.hide()
            })
        },

        clearSelection() {
            this.filter_not_selected = ''
            this.selected = []
        },

        getStatus(status) {
            if (status == 1) return 'published'
            else if (status == 2) return 'unpublished'
            else if (status == 3) return 'deleted'
            else if (status == 4) return 'ended'
            else if (status == 5) return 'converting'
        },

        getIconStatus(status) {
            if (status == 1) return 'fas fa-check'
            else if (status == 2) return 'fas fa-ban'
            else if (status == 3) return 'fas fa-trash-alt'
            else if (status == 4) return 'fas fa-calendar-check'
            else if (status == 5) return 'fas fa-wrench'
        },

        getColorStatus(status) {
            if (status == 1) return 'positive'
            else if (status == 2) return 'warning'
            else if (status == 3) return 'negative'
            else if (status == 4) return 'info'
            else if (status == 5) return 'info'
        },

        getOrder(name) {
            if (name == 'cancel') {
                if (this.$q.platform.is.mobile) return 'order-last'
                else return 'order-first'
            }
            else if (name == 'save') {
                if (this.$q.platform.is.mobile) return 'order-first'
                else return 'order-last'
            }
        }
    },

    created() {
        this.id_trail = this.$route.params.id
        this.request_selected({ pagination: this.selected_server_pagination })
    }
}
</script>

<style>

</style>
